export default __webpack_public_path__ + "static/media/BlackFrame05.312dea54.png";